import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Body22 from "./Body22";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageProjektyBody22() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body22/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageProjektyBody22;
